module.exports = __webpack_public_path__ + "static/media/junput.6a963bba.jpg";